import React from 'react'

const SuccessCircle = () => {
  return (
    <svg
      data-testid="icon-success-circle"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 35V35C11.715 35 5 28.285 5 20V20C5 11.715 11.715 5 20 5V5C28.285 5 35 11.715 35 20V20C35 28.285 28.285 35 20 35Z"
        stroke="#11BB77"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6667 16.6667L18.3333 25.0001L13.3333 20.0001"
        stroke="#11BB77"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { SuccessCircle }
